import React from 'react';
import { parseMeterChangeFile } from '../../utils/meterChangeFileParser';

const MeterChangeImport = ({ onImport }) => {
  const handleFileChange = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = () => {
      try {
        const text = String(reader.result ?? '').replace(/^\uFEFF/, ''); // strip BOM
        const result = parseMeterChangeFile(text);

        // normalize result to { success, message, rows }
        if (result && typeof result === 'object') {
          if (result.success === true || result.rows) {
            const message = result.message || `${(result.rows || []).length} row(s) imported.`;
            onImport({ success: !!result.success, message, rows: result.rows || [] });
          } else {
            const msg = result.message || (result.errors ? result.errors.join('; ') : 'Import failed.');
            onImport({ success: false, message: msg, rows: [] });
          }
        } else {
          onImport({ success: false, message: 'Import failed. Invalid file format.', rows: [] });
        }
      } catch (err) {
        onImport({
          success: false,
          message: 'Import failed. Invalid file format.',
          rows: [],
        });
      } finally {
        // clear the input so same file can be re-imported if needed
        const input = document.getElementById('file-import-mc');
        if (input) input.value = '';
      }
    };

    reader.readAsText(file);
  };

  return (
    <>
      <input
        id="file-import-mc"
        type="file"
        accept=".csv,.tsv,.txt"
        data-testid="file-input-mc"
        hidden
        onChange={handleFileChange}
      />
    </>
  );
};

export default MeterChangeImport;
